﻿jQuery(function ($) {

    /*===============================
        Sticky header
    ================================*/
    var $header = $('.main_header');
    var $body = $('body');
    var headerTicking = false;

    function syncStickyHeader() {
        var stuck = $(window).scrollTop() > 20;
        $header.toggleClass('sticky', stuck);
        $body.toggleClass('header-sticky', stuck);
        headerTicking = false;
    }

    $(window).on('scroll resize', function () {
        if (!headerTicking) {
            headerTicking = true;
            window.requestAnimationFrame(syncStickyHeader);
        }
    });
    syncStickyHeader();

    /*===============================
        Testimonials carousel
    ================================*/
    var $slider = $('.real_garages_slider');

    if ($slider.length && $.fn.owlCarousel) {
        var itemCount = $slider.find('.item').length;

        $slider.owlCarousel({
            loop: itemCount > 3,
            margin: 0,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            smartSpeed: 800,
            navText: [
                '<span class="custom-prev"></span>',
                '<span class="custom-next"></span>'
            ],
            responsive: {
                0: { items: 1, nav: itemCount > 1 },
                600: { items: 2, nav: itemCount > 2 },
                1000: { items: 3, nav: itemCount > 3 }
            }
        });
    }

    /*===============================
        Button hover ripple
    ================================*/
    $('.btn-ctn')
        .append('<span></span>')
        .on('mouseenter mouseout', function (e) {
            var parentOffset = $(this).offset();
            $(this).find('span').css({
                top: e.pageY - parentOffset.top,
                left: e.pageX - parentOffset.left
            });
        });

});

/* =====================================================
   Feature Carousel
   ===================================================== */
(function ($) {
    var $fc = $('.feature-carousel');
    if (!$fc.length || !$.fn.owlCarousel) return;

    $fc.owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        dots: true,
        nav: true,
        navText: ['<span></span>', '<span></span>'],
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        smartSpeed: 700
    });
}(jQuery));

/* =====================================================
   Mission Equation
   ===================================================== */
(function ($) {
    var $equation = $('[data-mission-equation]').first();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resetEquation($target) {
        if (!$target.length) {
            return;
        }

        $target.removeClass('is-active is-complete');
        $target.find('[data-equation-step]').removeClass('is-visible');
    }

    function runEquation($target) {
        var $steps;

        if (!$target.length || $target.hasClass('is-complete')) {
            return;
        }

        $steps = $target.find('[data-equation-step]');
        resetEquation($target);
        $target.addClass('is-active');

        if (reducedMotion) {
            $steps.addClass('is-visible');
            $target.addClass('is-complete');
            return;
        }

        $steps.each(function (index) {
            var delay = index === 0 ? 120 : index === 1 ? 620 : 980 + ((index - 2) * 140);

            setTimeout(function () {
                $(this).addClass('is-visible');
            }.bind(this), delay);
        });

        setTimeout(function () {
            $target.addClass('is-complete');
        }, 980 + Math.max(0, $steps.length - 2) * 140 + 220);
    }

    function initMissionEquation() {
        if (!$equation.length) {
            return;
        }

        $equation.addClass('is-enhanced');

        if (reducedMotion || !('IntersectionObserver' in window)) {
            runEquation($equation);
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    runEquation($equation);
                    observer.disconnect();
                }
            });
        }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

        observer.observe($equation[0]);
    }

    initMissionEquation();
}(jQuery));

/* =====================================================
   Contact modal
   ===================================================== */
(function () {
    var modal = document.querySelector('[data-contact-modal]');
    if (!modal) {
        // On the Contact page itself, "Contact us" links jump to the page's own form.
        var pageForm = document.querySelector('[data-contact-page-form]');
        if (pageForm) {
            document.addEventListener('click', function (event) {
                if (!event.target.closest('[data-contact-trigger]')) {
                    return;
                }
                event.preventDefault();
                pageForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
                var first = pageForm.querySelector('input:not([type="hidden"]), textarea');
                if (first) {
                    first.focus({ preventScroll: true });
                }
            });
        }
        return;
    }

    var dialog = modal.querySelector('[data-contact-dialog]');
    var lastFocus = null;

    function isOpen() {
        return modal.classList.contains('is-open');
    }

    function openModal() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        // Force reflow so the open transition plays
        void modal.offsetWidth;
        modal.classList.add('is-open');
        document.documentElement.classList.add('tune-contact-open');

        var focusTarget =
            modal.querySelector('[data-contact-success]') ||
            modal.querySelector('input, textarea, button:not([data-contact-close])');
        if (focusTarget) {
            focusTarget.focus({ preventScroll: true });
        }
    }

    function closeModal() {
        if (!isOpen()) {
            return;
        }

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('tune-contact-open');

        window.setTimeout(function () {
            if (!isOpen()) {
                modal.hidden = true;
            }
        }, 220);

        if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus({ preventScroll: true });
        }
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-contact-trigger]');
        if (trigger) {
            event.preventDefault();
            event.stopPropagation();
            openModal();
            return;
        }

        if (event.target.closest('[data-contact-close]')) {
            event.preventDefault();
            closeModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
            event.preventDefault();
            closeModal();
        }
    });

    if (modal.querySelector('[data-contact-success]') || modal.querySelector('.tune-contact_errors')) {
        openModal();
    }
}());

/* =====================================================
   Keep --site-header-height in sync with the rendered header
   ===================================================== */
(function () {
    var header = document.querySelector('.main_header');
    if (!header) {
        return;
    }

    function sync() {
        var height = Math.round(header.getBoundingClientRect().height);
        if (height > 0) {
            document.documentElement.style.setProperty('--site-header-height', height + 'px');
        }
    }

    sync();
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync);

    if (window.ResizeObserver) {
        new ResizeObserver(sync).observe(header);
    }
}());

/* =====================================================
   In-page nav: reliable single-click anchor scrolling
   ===================================================== */
(function () {
    function getHeaderOffset() {
        var header = document.querySelector('.main_header');
        return (header ? header.offsetHeight : 64) + 8;
    }

    function scrollToTarget(id, behavior) {
        var target = document.getElementById(id);
        if (!target) {
            return false;
        }

        var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
            top: Math.max(0, top),
            behavior: reduced ? 'auto' : (behavior || 'smooth')
        });
        return true;
    }

    function closeDrawer() {
        var drawer = document.getElementById('Right_Funnel');
        if (drawer && drawer.classList.contains('show') && window.bootstrap && window.bootstrap.Offcanvas) {
            var instance = window.bootstrap.Offcanvas.getInstance(drawer);
            if (instance) {
                instance.hide();
            }
        }
    }

    // Handles "#id" and "/#id" (plus locale-prefixed versions) whenever the link
    // points at the page we are already on, so the fixed header offset is respected.
    function handlePageAnchorClick(event) {
        var link = event.target.closest('a[href*="#"]');
        if (!link || link.hasAttribute('data-contact-trigger') || link.target === '_blank') {
            return;
        }

        var url;
        try {
            url = new URL(link.href, window.location.href);
        } catch (err) {
            return;
        }

        var hash = url.hash.replace('#', '');
        if (!hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
            return;
        }

        if (!document.getElementById(hash)) {
            return;
        }

        event.preventDefault();
        closeDrawer();
        history.pushState(null, '', '#' + hash);
        // Let the drawer start closing before measuring, so body scroll lock is released.
        window.setTimeout(function () {
            scrollToTarget(hash);
        }, 60);
    }

    function scrollToInitialHash() {
        var hash = window.location.hash.replace('#', '');
        if (!hash) {
            return;
        }

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                scrollToTarget(hash, 'auto');
            });
        });
    }

    document.addEventListener('click', handlePageAnchorClick);
    window.addEventListener('load', scrollToInitialHash);
    window.addEventListener('hashchange', function () {
        var hash = window.location.hash.replace('#', '');
        if (hash) {
            scrollToTarget(hash, 'auto');
        }
    });
}());

/* =====================================================
   Out-of-stock waitlist popup

   The popup only announces the sold-out state. Signups are collected by the Shopify
   Forms block on the waitlist page, which renders inside a shadow root and exposes no
   submit event, so arriving on that page is what marks a visitor as handled. Someone
   who leaves without submitting is suppressed too, which beats re-opening the same
   popup on every page they visit.
   ===================================================== */
(function () {
    var SEEN_KEY = 'tuneWaitlistSeen';
    var HANDLED_KEY = 'tuneWaitlistHandled';
    var lastFocus = null;
    var openTimer = null;
    var modal = null;

    // Private-mode Safari throws on storage access, so every read/write is guarded.
    function readStore(store, key) {
        try {
            return window[store].getItem(key);
        } catch (err) {
            return null;
        }
    }

    function writeStore(store, key, value) {
        try {
            window[store].setItem(key, value);
        } catch (err) {
            /* no-op */
        }
    }

    modal = document.querySelector('[data-waitlist-modal]');

    // Nothing to advertise once they have reached the form itself.
    if (/\/waitlist(\.html)?$/.test(window.location.pathname)) {
        writeStore('localStorage', HANDLED_KEY, '1');
        if (modal) {
            modal.remove();
        }
        return;
    }

    if (!modal) {
        return;
    }

    function hasHandled() {
        return readStore('localStorage', HANDLED_KEY) === '1';
    }

    function seenThisSession() {
        return readStore('sessionStorage', SEEN_KEY) === '1';
    }

    function isOpen() {
        return modal.classList.contains('is-open');
    }

    function contactModalOpen() {
        var contact = document.querySelector('[data-contact-modal]');
        return !!contact && contact.classList.contains('is-open');
    }

    function openModal() {
        if (isOpen()) {
            return;
        }

        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        // Force reflow so the open transition plays
        void modal.offsetWidth;
        modal.classList.add('is-open');
        document.documentElement.classList.add('tune-waitlist-open');
        writeStore('sessionStorage', SEEN_KEY, '1');

        var focusTarget =
            modal.querySelector('[data-waitlist-cta]') ||
            modal.querySelector('button:not([data-waitlist-close])');
        if (focusTarget) {
            focusTarget.focus({ preventScroll: true });
        }
    }

    function closeModal() {
        if (!isOpen()) {
            return;
        }

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('tune-waitlist-open');

        window.setTimeout(function () {
            if (!isOpen()) {
                modal.hidden = true;
            }
        }, 240);

        if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus({ preventScroll: true });
        }
    }

    function scheduleAutoOpen() {
        if (modal.getAttribute('data-waitlist-auto') !== 'true' || hasHandled() || seenThisSession()) {
            return;
        }

        var delay = parseInt(modal.getAttribute('data-waitlist-delay'), 10);
        if (isNaN(delay) || delay < 0) {
            delay = 5000;
        }

        openTimer = window.setTimeout(function () {
            if (!contactModalOpen()) {
                openModal();
            }
        }, delay);
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-waitlist-trigger]');
        if (trigger) {
            event.preventDefault();
            event.stopPropagation();
            window.clearTimeout(openTimer);
            openModal();
            return;
        }

        // Follow the link normally, but stop nagging them from here on.
        if (event.target.closest('[data-waitlist-cta]')) {
            writeStore('localStorage', HANDLED_KEY, '1');
            return;
        }

        if (event.target.closest('[data-waitlist-close]')) {
            event.preventDefault();
            closeModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
            event.preventDefault();
            closeModal();
        }
    });

    scheduleAutoOpen();
}());
/* =====================================================
   Keep keyboard focus inside whichever modal is open
   ===================================================== */
(function () {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') {
            return;
        }

        var dialog = document.querySelector('.tune-contact.is-open [role="dialog"], .tune-waitlist.is-open [role="dialog"]');
        if (!dialog) {
            return;
        }

        var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
            return el.offsetParent !== null;
        });
        if (!items.length) {
            return;
        }

        var first = items[0];
        var last = items[items.length - 1];

        if (!dialog.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });
}());
